export default function truncate(value, limit) {
  if (!value) return "";
  return value.length > limit ? value.substring(0, limit) + "..." : value;
}
